"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderControl = void 0;
var react_1 = __importDefault(require("react"));
var container_1 = require("./container");
var react_redux_1 = require("react-redux");
var main_1 = require("../reducers/slices/main");
var account_1 = require("../screens/pages/account/account");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../constants/routes");
var logos_config_1 = require("../../../logos.config");
var HeaderControl = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var location = (0, react_router_dom_1.useLocation)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var menuItems = [
        {
            title: "Auctions",
            route: routes_1.AUCTIONS_ROUTE,
            selection_indication: [
                // multiple routes that should be highlighted when the user is on the page
                routes_1.AUCTIONS_ROUTE,
                routes_1.AUCTION_COMPLETE_ROUTE,
                routes_1.LIVE_ROUTE,
                routes_1.AUCTION_DETAILS_ROUTE,
                routes_1.LOT_COMPLETE_DETAILS_ROUTE,
                routes_1.LOT_DETAILS_ROUTE,
            ],
        },
        {
            title: "Contact",
            route: routes_1.CONTACT_ROUTE,
            selection_indication: [routes_1.CONTACT_ROUTE],
        },
    ];
    var username = "".concat(user.name).toUpperCase();
    return (react_1.default.createElement("div", { className: "bg-header shadow-lg shadow-gray-300 sticky top-0 z-50" },
        react_1.default.createElement(container_1.ContainerControl, null,
            react_1.default.createElement("div", { className: "flex flex-row gap-8 px-4 items-center" },
                react_1.default.createElement("div", { className: "flex-1 flex flex-col md:flex-row gap-4 md:gap-8" },
                    react_1.default.createElement("div", { className: "flex relative justify-center" },
                        react_1.default.createElement("div", { className: "w-72 " },
                            react_1.default.createElement("div", { className: "lg:absolute  rounded-b-3xl md:rounded-b-none lg:rounded-b-3xl h-[100px] p-4 w-full  ".concat(logos_config_1.logos.dark.boxShadow, "\n                    ").concat(logos_config_1.logos.dark.background, "\n                  ") },
                                react_1.default.createElement("img", { src: logos_config_1.logos.dark.img, className: "h-full w-full object-contain" })))),
                    react_1.default.createElement("div", { className: "flex-1 flex justify-between items-center" },
                        react_1.default.createElement("div", { className: "flex-1 flex flex-row gap-4 items-center py-4" }, menuItems.map(function (item, index) {
                            var selected = item.selection_indication.some(function (route) { return location.pathname.includes(route); });
                            return (react_1.default.createElement("div", { key: "menu-item-".concat(index), className: "h-12 flex justify-center items-center px-4 cursor-pointer border-primary tex-lg font-bold\n                        ".concat(selected ? "border-b-4  text-black" : "bg-transparent text-black hover:border-b-4 hover:border-warning", "\n                        \n                      "), onClick: function () {
                                    navigate(item.route);
                                } }, item.title.toUpperCase()));
                        })),
                        react_1.default.createElement("div", { className: "".concat(user.entity_id ? "bg-white text-black border-2 border-black" : ""
                            //  "bg-primary text-white"
                            , " \n                  flex justify-center items-center rounded-lg px-4 h-12 cursor-pointer hover:bg-gray-200 transition-colors\n                "), onClick: function () {
                                if (user.entity_id) {
                                    dispatch((0, main_1.setDrawer)({
                                        open: true,
                                        content: react_1.default.createElement(account_1.AccountScreen, null),
                                    }));
                                }
                                else {
                                    // dispatch(
                                    //   setDrawer({
                                    //     open: true,
                                    //     content: (
                                    //       <div className="w-96">
                                    //         <LogInComponent />
                                    //       </div>
                                    //     ),
                                    //   }),
                                    // );
                                }
                            } }, user.entity_id ? (username.length > 14 ? "".concat(username.substring(0, 10), "...") : username) : "")))))));
};
exports.HeaderControl = HeaderControl;
